module.exports = __webpack_public_path__ + "img/linux.c9637230.svg";